import React from 'react';
import { Grid } from '@mui/material';
import { DateTimeInput, required } from 'react-admin';
import { useController } from 'react-hook-form';
import { addHoursToDate } from '../../../utils';

export const EventSingleDateFields = () => {
  const startDateInput = useController({ name: 'startDate' });
  const endDateInput = useController({ name: 'endDate' });

  return (
    <Grid container columnSpacing={2}>
      <Grid item xs={3}>
        <DateTimeInput
          {...startDateInput.field}
          onChange={(e) => {
            startDateInput.field.onChange(e.target.value);
            if (e.target.value) {
              endDateInput.field.onChange(
                addHoursToDate(1, new Date(e.target.value)),
              );
            }
          }}
          source="startDate"
          label="Start date"
          validate={[required()]}
          fullWidth
        />
      </Grid>
      <Grid item xs={3}>
        <DateTimeInput
          {...endDateInput.field}
          source="endDate"
          label="End date"
          validate={[required()]}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};
